<template>
  <div>
    <Worktemp
      data-aos="fade-down"
      :workTitle="work.tittle"
      :workPara="work.para"
      :companyName="work.company"
      :yearName="work.year"
      :projectType="work.project"
    ></Worktemp>
    <WorkcoverImg :coverimg="work.coverimg" data-aos="fade-up" />
    <WorkTwoImg :TwoImgleft="work.TwoImgleft" :TwoImgRight="work.TwoImgRight" />
    <WorkThreeImg
      :ThreeImgleft="work.ThreeImgleft"
      :ThreeImgRight="work.ThreeImgRight"
    />
    <WorkcoverImg :coverimg="work.coverimg2" />
    <hire />
  </div>
</template>
<script>
import Worktemp from "@/components/Worktemp.vue";
import WorkcoverImg from "@/components/WorkcoverImg.vue";
import WorkTwoImg from "@/components/WorkTwoImg.vue";
import WorkThreeImg from "@/components/WorkThreeImg.vue";
export default {
  components: {
    Worktemp,
    WorkcoverImg,
    WorkTwoImg,
    WorkThreeImg,
  },
  data() {
    return {
      work: {
        tittle: "Zsites Landing Page",
        para: "Designed Foxglove Awards by Shutterstock 2021 Winning Website. We revamped the website for Cobold Digital. I did UI/UX for the website. From brainstorming sessions, design research, to final implementation, we covered all with solid teamwork. The brand new website represented Cobold with all its brand aesthetics, & a technology-first brand. ",
        company: "GLB International Services",
        year: "2021",
        project: "UI/UX",
        coverimg: "/img/gallery/ui/zsites-landing/cover.jpg",
        TwoImgleft: "/img/gallery/ui/zsites-landing/twoleft.svg",
        TwoImgRight: "/img/gallery/ui/zsites-landing/tworight.svg",
        ThreeImgleft: "/img/gallery/ui/zsites-landing/threeleft.svg",
        ThreeImgRight: "/img/gallery/ui/zsites-landing/threeright.svg",
        // coverimg2: "/img/gallery/ui/zsites-landing/cover2.jpg",
      },
    };
  },
};
</script>
